import { validateDate } from '../../../../shared/lib/validate-date'

export const documentsValidator = {
    type: {
        required: 'Тип документа является обязательным полем',
    },
    passportNumber: {
        required: 'Номер паспорта является обязательным полем',
        pattern: {
            value: /^[0-9]{2} [0-9]{2} [0-9]{6}$/,
            message: 'Серия состоит из 4 цифр, а номер — из 6',
        },
    },
    number: {
        required: 'Номер документа является обязательным полем',
        pattern: {
            value: /^(?!.*[^A-Z0-9])[A-Z0-9]{0,30}$/,
            message: 'Допустимые символы: цифры, текст на кириллице или латинице',
        },
    },
    dateOfIssue: {
        required: 'Дата выдачи паспорта является обязательным полем',
        validate: validateDate,
    },
    issuedBy: {
        required: 'Кем выдан паспорт является обязательным полем',
        pattern: {
            value: /^[А-ЯЁа-яе0-9 -/.№]{0,150}$/,
            message: 'Допустимые символы: кириллица, цифры, пробел, - / . №',
        },
    },
    unitCode: {
        required: 'Код подразделения является обязательным полем',
        pattern: {
            value: /^[0-9]{3}[-][0-9]{3}$/,
            message: 'Напишите в формате 000-000',
        },
    },
    placeOfBirth: {
        required: 'Место рождения является обязательным полем',
        pattern: {
            value: /^[А-ЯЁа-яе .-]+$/,
            message: 'Введите на кириллице',
        },
    },
    inn: {
        required: 'ИНН является обязательным полем',
        pattern: {
            value: /^[0-9]{12}$/,
            message: 'ИНН состоит из 12 цифр',
        },
    },
}
